module.exports = __webpack_public_path__ + "img/XDSM.45292f5c.png";